import { FeaturesQuery } from '@/graphql/graphql';
import { atom } from 'jotai';
import { LayerData } from './layers.atom';

export const selectedFeatureAtom = atom<
  | (FeaturesQuery['featuresByLayer'][number] & {
      isMoving?: boolean;
      isEditing?: boolean;
      isDraft?: boolean;
      onSave: (selectedFeature: any) => void;
    })
  | null
>(null);

export const layerPropertiesAtom = atom<(Partial<LayerData> & {}) | null>(null);

// Multi-feature highlight, driven by the AttributeTable and rendered by
// MapView + the 3D Viewer. Kept separate from selectedFeatureAtom (which is
// the single edit-target with isMoving/isDraft/onSave semantics).
export const highlightedFeatureIdsAtom = atom<Set<string>>(new Set<string>());
export const highlightedLayerIdAtom = atom<string | null>(null);
